"use client";

import { useEffect, useState } from "react";
import {
  Grid,
  Card,
  CardHeader,
  CardContent,
  Box,
  Typography,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import FileUploadArea from "./common/FileUploadArea";
import ImageGalleryCard from "./common/ImageGalleryCard";
import { useFileUploadMP } from "../../../../hooks/useUploadFileMP";
import { IMAGE_CATEGORY_LABELS } from "./constants/equipment-data";
import { useLocation } from "react-router-dom";
import { useDocuments } from "../../../../hooks/useDocuments";
import { UrlApi } from "../../../../../../services/apirest";
import { DownloadFiles } from "../../../../../../services/DownloadFiles";
import { useToast } from "../../../../../../Hooks/UseToast";
const initialImages = [];

export default function ImageGalleryTab() {
  const { equipo } = useLocation().state;
  const fileId = equipo.uuid_documentacion;

  const { uploadFile, isUploading, uploadProgress } = useFileUploadMP();
  const { removeDocument, getDocuments, documents, ViewFiles } = useDocuments(
    []
  );
  const { showToast, Toast } = useToast();

  const refetchImagenesDocs = () => getDocuments(fileId, "imagenes");

  useEffect(() => {
    if (fileId) refetchImagenesDocs();
  }, [fileId]);
  // 🔹 Subida de archivos
  const handleFileSelect = async (files) => {
    if (!fileId) {
      console.log("No hay ID de archivo");
      return;
    }

    try {
      const data = await uploadFile(files, "imagenes", fileId);
      console.log("Archivo subido:", data);

      await refetchImagenesDocs();
      showToast("Archivo cargado con éxito", "success");
    } catch (err) {
      showToast("Error al subir archivo", "error");
    }
  };
  const handleDocumentDelete = async (doc) => {
    await removeDocument(doc.id, doc.nombre);
    await refetchImagenesDocs();
    showToast("Archivo eliminado", "info");
  };

  const handleDocumentView = (document) => {
    ViewFiles(document.id_archivo + "-" + document.nombre, document.extension);
  };

  const handleDocumentDownload = (document) => {
    DownloadFiles(document.id_archivo + "-" + document.nombre);
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Card>
          <CardHeader
            title="Galería de Imágenes"
            subheader="Fotografías del equipo, diagramas visuales y documentación gráfica"
          />
          <CardContent>
            <Box sx={{ mb: 4 }}>
              <FileUploadArea
                title="Cargar Imágenes"
                description="Soporta JPG, PNG, GIF, BMP y SVG"
                acceptedTypes=".jpg,.jpeg,.png,.gif,.bmp,.svg"
                onFileSelect={handleFileSelect}
                isUploading={isUploading}
                uploadProgress={uploadProgress}
              />
            </Box>

            <Grid container spacing={3}>
              {documents.map((image) => (
                <Grid item xs={12} sm={6} md={4} key={image.id}>
                  <ImageGalleryCard
                    image={image}
                    onView={handleDocumentView}
                    onDownload={handleDocumentDownload}
                    onDelete={handleDocumentDelete}
                  />
                </Grid>
              ))}
            </Grid>
          </CardContent>
        </Card>
      </Grid>
      {Toast}
    </Grid>
  );
}
